import { useEffect } from 'react';
import style from './ConnectWalletPage.module.scss';
import { WalletConnectLoginButton, LedgerLoginButton, ExtensionLoginButton } from '@multiversx/sdk-dapp/UI';
import { useNavigate } from 'react-router-dom';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';

function ConnectWalletPage() {
    const navigate = useNavigate();
    const { account } = useGetAccountInfo();
    const isConnected = account && account.address;

    useEffect(() => {
        if (isConnected) {
            navigate('/dashboard');
        }
    }, [isConnected, navigate]);

    return (
        <div className={style.connectWalletPage}>
            <div className="container">
                <h1>Connect Your Wallet</h1>
                <span>Choose one of the option below</span>
                <div className="options">
                    <WalletConnectLoginButton
                        callbackRoute={'/dashboard'}
                        onLoginRedirect={'/dashboard'}
                        buttonClassName="option"
                    >
                        <span>Mobile</span>
                        <img src="assets/icons/x-portal-app.png" alt="xPortal App icon" />
                        <strong>xPortal App</strong>
                    </WalletConnectLoginButton>
                    <LedgerLoginButton
                        callbackRoute={'/dashboard'}
                        onLoginRedirect={'/dashboard'}
                        buttonClassName="option"
                    >
                        <span>Hardware</span>
                        <img src="assets/icons/ledger.png" alt="Ledger icon" />
                        <strong>Ledger</strong>
                    </LedgerLoginButton>
                    <ExtensionLoginButton
                        callbackRoute={'/dashboard'}
                        onLoginRedirect={'/dashboard'}
                        buttonClassName="option"
                    >
                        <span>Extension</span>
                        <img src="assets/icons/defi-wallet.png" alt="Defi Wallet icon" />
                        <strong>Defi Wallet</strong>
                    </ExtensionLoginButton>
                </div>
            </div>
        </div>
    );
}

export default ConnectWalletPage;
